import OrganizationList from '@/components/organization/List'
import OrganizationListMap from '@/components/organization/ListMap'
import OrganizationCreate from '@/components/organization/Create'
import OrganizationUpdate from '@/components/organization/Update'
import OrganizationShow from '@/components/organization/Show'
import OrganizationShowMap from '@/components/organization/ShowMap'

export default [
  {
    name: 'OrganizationList',
    path: '/organizations/',
    component: OrganizationList
  },
  {
    name: 'OrganizationListMap',
    path: '/organizations-map/',
    component: OrganizationListMap
  },
  {
    name: 'OrganizationCreate',
    path: '/organizations/create',
    component: OrganizationCreate
  },
  {
    name: 'OrganizationUpdate',
    path: '/organizations/edit/:id',
    component: OrganizationUpdate
  },
  {
    name: 'OrganizationShow',
    path: '/organizations/show/:id',
    component: OrganizationShow
  },
  {
    name: 'OrganizationShowMap',
    path: '/organizations/map/:id',
    component: OrganizationShowMap
  }
]
